function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS = {
  auth: '/auth',
  app: ''
};

export const PATH_PAGE = {
  auth: {
    root: ROOTS.auth,
    login: path(ROOTS.auth, '/login'),
    newPassword: path(ROOTS.auth, '/new-password'),
    newPin: path(ROOTS.auth, '/new-pin'),
    loginUnprotected: path(ROOTS.auth, '/login-unprotected'),
    register: path(ROOTS.auth, '/register'),
    registerUnprotected: path(ROOTS.auth, '/register-unprotected'),
    resetPassword: path(ROOTS.auth, '/reset-password'),
    verify: path(ROOTS.auth, '/verify')
  },
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment'
};

const singleTicketRoute3 = '/retail3/single-ticket/:id';

const paths = {
  root: ROOTS.app,
  appointment: {
    root: path(ROOTS.app, '/'),
    slotItems: path(ROOTS.app, '/manager/slotitems'),
    addSlotItem: path(ROOTS.app, '/manager/slotitems/add'),
    editSlotItem: path(ROOTS.app, '/manager/slotitems/edit/:id')
  },
  retail3: {
    root: path(ROOTS.app, '/retail3'),
    single: path(ROOTS.app, singleTicketRoute3)
  },
  staffmgmt: {
    root: path(ROOTS.app, '/manager/staffmanagement')
  },
  therapist: {
    root: path(ROOTS.app, '/manager/therapist'),
    add: path(ROOTS.app, '/manager/therapist/add'),
    edit: path(ROOTS.app, '/manager/therapist/edit/:id'),
    profile: path(ROOTS.app, '/manager/therapist/profile/:id')
  },
  shiftLead: {
    root: path(ROOTS.app, '/shiftlead')
  },
  giftCards: {
    root: path(ROOTS.app, '/giftcard-inquiry')
  },
  promotions: {
    root: path(ROOTS.app, '/manager/promotions')
  },
  categorized: {
    root: path(ROOTS.app, '/categorized')
  },
  product: {
    root: path(ROOTS.app, '/admin/product'),
    add: path(ROOTS.app, '/admin/product/add'),
    edit: path(ROOTS.app, '/admin/product/edit/:id'),
    availability: path(ROOTS.app, '/admin/product/availability/:id')
  },
  product2: {
    root: path(ROOTS.app, '/admin/product2')
  },
  credit: {
    root: path(ROOTS.app, '/admin/credit')
  },
  receipts: {
    root: path(ROOTS.app, '/receipts/details/:id')
  },
  customer: {
    root: path(ROOTS.app, '/customer'),
    add: path(ROOTS.app, '/customer/add'),
    edit: path(ROOTS.app, '/customer/edit/:id'),
    amd: path(ROOTS.app, '/customer/amd/:id'),
    profile: {
      root: path(ROOTS.app, '/customer/profile/:id')
    }
  },
  user: {
    root: path(ROOTS.app, '/user')
  },
  terminals: {
    root: path(ROOTS.app, '/terminals')
  },
  studiodashboard: {
    root: path(ROOTS.app, '/dashboard')
  },
  reports: {
    root: path(ROOTS.app, '/reports')
  },
  prices: {
    root: path(ROOTS.app, '/admin/prices')
  }
};

export const PATH_APP = paths;
